let UTILS = require("../libs/utils.js");
module.exports = {
  id: "bhop",
  name: "Parkour",
  alias: "bhop",
  sendR: 5,
  endStats: ["sid", "name", "score", "deaths"],
  noKick: true,
  friendly: true,
  logTime: true,
  showMS: true,
  ownTime: true,
  allowReset: true,
  showHour: true,
  viewDis: 1000,
  custUI: function (p9058, p9059, p9060) {
    if (p9058.doLogTime && (weapHolder.style.display = "none", bottomRight.style.display = "none", speedRunHolder.style.display = "block", speedRunReset.style.display = p9058.mode && p9058.mode.allowReset ? "inline-block" : "none", p9060)) {
      var v7683;
      var vLS23 = "";
      for (var v7684 = p9058.map.manager.scorezones.length, vLN01170 = 0; vLN01170 < v7684; ++vLN01170) {
        v7683 = vLN01170 + 1;
        if (vLN01170 < p9059.maxSpdRChck) {
          vLS23 += "<div class='speedRunItem" + (vLN01170 == 0 ? " sriAct" : "") + "' id='spdRunI" + v7683 + "'>Point " + v7683 + "<span class='speedRunITim' id='spdRunIVal" + v7683 + "'>0:00</span></div>";
        }
      }
      if (vLS23 == "") {
        vLS23 = "<div>No Score Zones</div>";
      }
      speedRunList.innerHTML = vLS23;
      speedRunInfo.innerHTML = "Any% <span style='float:right;color:#fff'><span id='spdrnZC'  style='color:#fff'>0</span>/" + v7684 + "<i class='material-icons' style='color:#fff;font-size:30px;margin-left:10px'>flag</i></span>";
      speedRunTimer.innerHTML = "00:00.0";
    }
  }
};